import { GlobalStyles } from '@mui/material'

const globalStyles = (
	<GlobalStyles
		styles={{
			'.custom-grid-wrapper': {
				// Set the background color to white
				'.Global-DataGrid': {
					'borderRadius': 0,
					'border': 'none',
					'backgroundColor': '#fff',
					'&.MuiDataGrid-root': {
						'& .MuiDataGrid-row:hover': {
							backgroundColor: '#f5f5f5', // Default hover color for rows
						},
						'& .MuiDataGrid-pinnedColumns .MuiDataGrid-row:hover': {
							backgroundColor: 'inherit', // Disable hover color for pinned rows
						},
						'& .MuiDataGrid-row:hover .MuiDataGrid-cell--pinnedLeft': {
							backgroundColor: 'inherit', // Disable hover color for pinned right cells
						},
					},
				},
			},
			'.Global-DataGrid': {
				'borderRadius': 0,
				'border': 'none',
				'&.MuiDataGrid-root': {
					'borderRadius': 0,
					'border': 'none',
					'.MuiDataGrid-columnHeaderTitle': {
						fontWeight: 600,
					},
					'.MuiDataGrid-row:hover': {
						//	backgroundColor: '#f5f5f5', // Light gray background on hover
						cursor: 'pointer', // Change cursor to pointer
					},
					'.MuiDataGrid-cell--pinnedLeft': {
						backgroundColor: '#fff', // Light gray background for pinned left cells
					},
					'.MuiDataGrid-cell--pinnedRight': {
						backgroundColor: '#fff', // Light gray background for pinned right cells
					},
					'.MuiDataGrid-cell': {
						padding: '0 10px',
						borderBottom: 'none',
						display: 'flex',
						alignItems: 'center',
						// backgroundColor: 'white',
						lineHeight: 'unset',
					},
					'.MuiDataGrid-row--dynamicHeight > .MuiDataGrid-cell': {
						whiteSpace: 'nowrap',
					},
				},
			},
		}}
	/>
)

export default globalStyles
